import React from 'react'
import GalleryExternal from '../../components/galleryInternal/galleryExternal'

const GalleryInternalPage = () => {
  return (
    <div >
        <GalleryExternal/>
    </div>
  )
}

export default GalleryInternalPage